import React from 'react';
import { Input, Button, Select, Textarea, PaperClip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { DownloadIcon, Upload2Icon } from 'assets/icons';
import { ProductService } from 'services';

interface Props {
	onClose?: any;
}

class ModalUpload extends React.Component<Props> {

	state = {
		form: {
			file: ''
		}
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (!this.state.form.file) {
			Globals.showError("Por favor, suba el archivo para continuar");
			return;
		}

		const res: any = await ProductService.upload({
			hasFile: true,
			// @ts-ignore,
			file: this.state.form.file?.value || ''
		});
		if (res.errors?.length > 0) {
			Globals.showHtml(`
				<p>Se detectaron algunos errores al subir el archivo:</p>
				${ res.errors.map((item: any) => item = `<p style="font-size: 13px; margin-bottom: 0px; text-align: left;">${ item }</p>`).join('') }
			`);
		}
		else {
			Globals.showSuccess("Se ha creado los productos correctamente");
			this.props.onClose();
		}
	}
	
	render() {
		return (
			<div id="modal-upload-product">
				<div className="form-blue">
					<p className="title-instructions">Paso 1</p>
					<p className="instructions">Descargar el archivo de Excel</p>
					<div className="text-center">
						<a href={ Constants.BASE_PUBLIC + 'files/upload.xlsx'} target="_blank">
							<Button className="btn-download">
								<img src={ DownloadIcon } />
								Descargar Archivo Excel
							</Button>
						</a>
					</div>
					<p className="title-instructions">Paso 2</p>
					<p className="instructions">Carga la información en el orden indicado en el excel</p>
					<p className="title-instructions">Paso 3</p>
					<p className="instructions">Sube tu archivo excel con la información</p>
					<div className="text-center">
						<PaperClip
							formats={['xlsx']}
							onChange={ (e: any) => {
								this.setState({
									form: {
										...this.state.form,
										file: e.target
									}
								})
							} }>
							<div className="btn-upload">
								{ this.state.form.file != '' ? 'Archivo cargado' : 'Subir formato' }
							</div>
						</PaperClip>
					</div>
				</div>
				<div className="text-center">
					<Button className="btn-send" onClick={ this.submit }>
						Guardar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalUpload;